/* global VueRouter:true */
/* global iview:true */
import store from '@/store'
import Dashboard from '../layout/home'
import HomeView from '../layout/home/home'
import HomeContentView from '../layout/home/mainContent'
import LoginView from '../layout/login'
import NotFoundComponent from '../layout/404'
import NoPermission from '../layout/noPermission'
import PaperReviewHome from '../layout/paperReview'

const vueRouter = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      redirect: '/shell/dashboard',
      component: Dashboard,
      children: [
        {path: '/shell/dashboard', component: HomeView},
        {path: '/shell/404', component: NotFoundComponent},
        {path: '/shell/noPermission', component: NoPermission}
      ]
    },
    {
      path: '/shell/*',
      component: Dashboard,
      children: [
        {path: '/shell/*', component: HomeContentView}
      ]
    },
    {
      path: '/login',
      name: '登录',
      component: LoginView
    },
    {
      path: '/paperReview',
      name: '评阅登陆',
      component: PaperReviewHome
    },
    {
      path: '*',
      name: '404',
      component: NotFoundComponent
    }
  ]
})

// 验证用户是否登录
vueRouter.beforeEach((to, from, next) => {
  const whiteList = ['/login', '/404', '/noPermission', '/paperReview']// 验证白名单

  iview.LoadingBar.start();
  // 如果是页面刷新，state值被清空，从session中获取
  if (!store.state.user.uuid) {
    store.commit('sessionInit')
    store.commit('roleListInit')
    store.commit('roleInit')
  }
  const auth = store.state.user.token
  const role = store.state.role
  if (!auth) {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next({
        path: '/login',
        query: {
          redirect: to.path
        }
      })
    }
  }
  // 已登录的情况再去登录页，跳转至首页
  if (to.path === '/login') {
    if (auth && role && role.id) {
      next('/')
    }
  }
  next()
})
vueRouter.afterEach(route => {
  iview.LoadingBar.finish()
})
export default vueRouter



// WEBPACK FOOTER //
// ./src/router/index.js